<template>
    <activities :project-id="$route.params.slug" @tab-changed="changeTab" />
</template>

<script>
    import Activities from '../../../components/Activities.vue'
    import { mapActions } from 'vuex'

    export default {
        components: {
            Activities
        },

        mounted () {
            this.fetchActivities({project_id: this.$route.params.slug})
        },

        methods: {
            ...mapActions({
                fetchActivities: 'fetchActivities'
            }),

            changeTab(route) {
                this.$emit('tab-changed', route)
            }
        }
    }
</script>
